import _equals from "ramda/es/equals";
import _length from "ramda/es/length";
import _compose from "ramda/es/compose";
import _filter from "ramda/es/filter";
import _curry from "ramda/es/curry";
export default _curry(function (len, list) {
  return _filter(_compose(_equals(len), _length), list);
});